export default __webpack_public_path__ + "static/media/profile-jak.3b10a5f3.png";